<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      row-id="seqno"
      resizable
      auto-resize
      highlight-hover-row
      :height="height"
      :loading="loading"
      :data="data"
      :columns="tableColumns"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #displayImportMsg="{ row }">
        <div
          v-if="row.errorMsgs && row.errorMsgs.length"
          :class="{ 'mb-2': row.warningMsgs && row.warningMsgs.length }"
          style="color: #f56c6c;"
        >
          <div
            v-for="(errorMsg, index) in row.errorMsgs"
            :key="index"
            :class="{ 'mt-1': index }"
          >
            <span class="mr-1">{{ index + 1 }}.</span>
            <span>{{ errorMsg }}</span>
          </div>
        </div>

        <div
          v-if="row.warningMsgs && row.warningMsgs.length"
          style="color: #e6a23c;"
        >
          <div
            v-for="(warningMsg, index) in row.warningMsgs"
            :key="index"
            :class="{ 'mt-1': index }"
          >
            <span class="mr-1">{{ index + 1 }}.</span>
            <span>{{ warningMsg }}</span>
          </div>
        </div>
      </template>

      <template #empty>
        <div>{{ $l('INDEX.table_label_no_data') || '暂无数据！' }}</div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import lodash from 'lodash'
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  computed: {
    height() {
      const h = this.tableHeight - 50
      return h <= 400 ? 400 : h
    },
    data() {
      if (!this.tableData?.length) return []

      return this.tableData
        .flatMap((item) => {
          const { details, ...info } = item
          return lodash.map(details, (detail) => {
            return {
              ...info,
              detail,
              errorMsgs: lodash.concat(info.errorMsgs, detail.errorMsgs),
            }
          })
        })
        .map((item, index) => ({ ...item, index }))
    },
  },
}
</script>

<style lang="scss" scoped></style>
